var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending-task-list-item",class:{ odd: _vm.index % 2 === 1 }},[_c('div',{staticClass:"col type"},[_vm._v(_vm._s(_vm.item.pendingTaskTypeDisplay))]),_c('div',{staticClass:"col detail"},[_c('detail-list',{attrs:{"item":_vm.item}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }